import { render, staticRenderFns } from "./DeleteEventDialog.vue?vue&type=template&id=0c40b252"
import script from "./DeleteEventDialog.vue?vue&type=script&lang=js"
export * from "./DeleteEventDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports